import React, { Component } from 'react'
import styled from 'styled-components'

import IconArrowDown from '../../assets/icons/arrow-down-blue.svg'
import IconArrowUp from '../../assets/icons/arrow-up-blue.svg'

const MoreLessBtnStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  .moreLessBtnContainer {
    background-color: #EDEEF3;
    padding: 12px 20px;
    border-radius: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      font-size: 1em;
      font-weight: 500;
      color: #0B33F8;
    }

    img {
      width: 25px;
      margin-left: 4px;
    }
  }
`;

export default class MoreLessBtn extends Component {
  render() {
    const { state, changeState } = this.props;
    return (
      <MoreLessBtnStyle>
        {state ?
          <div className="moreLessBtnContainer" onClick={changeState}><span>Mostra di più</span><img src={IconArrowDown} alt="Icon Mostra di Più"/></div>
          :
          <div className="moreLessBtnContainer" onClick={changeState}><span>Mostra di meno</span><img src={IconArrowUp} alt="Icon Mostra di Meno"/></div>
        }
      </MoreLessBtnStyle>
    )
  }
}
